import { api } from "../../utils/api";

import { getAccount } from "../GlobalRoles/getAccount";

export const onSubmitEditCurrentAccount = async (
  resetAccount,
  setLoading,
  setVisible,
  data
) => {
  try {
    var id = data.id;
    setLoading(true);
    await api.put(`current-account/${id}`, data);

    // Executar GetAccount após a atualização bem-sucedida
    await getAccount();

    resetAccount();
  } catch (e) {
    resetAccount();
  } finally {
    setVisible(false);
  }
};
